import { Suspense } from 'react';
import { CompanyGeneralInformation, CompanySites } from '@features';
import { Grid, Skeleton, Stack } from '@mantine/core';

const SKELETON_MIN_HEIGHT = 120;

export const CompanyDetailsGeneralPage: React.FC = () => {
  return (
    <Stack py="md">
      <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
        <Grid>
          <Grid.Col span={4}>
            <CompanyGeneralInformation />
          </Grid.Col>
          <Grid.Col span={8}>
            <CompanySites />
          </Grid.Col>
        </Grid>
      </Suspense>
    </Stack>
  );
};
